import { Stack, Box } from "@mui/material";
import { MuiVideoCard, MuiChannelCard } from "./";
const MuiVideos = ({ videos }) => {
  //console.log(videos);
  return (
    <Stack direction="row" gap={2} flexWrap="wrap" justifyContent="flex-start">
      {videos.map((item, index) => {
            {/* console.log(item) */}
        return (
          <Box key={index}>
            {item.id.videoId && <MuiVideoCard video={item} />}
            {item.id.channelId && (
              <MuiChannelCard channelDetails={item} />
            )}
          </Box>
        );
      })}
    </Stack>
  );
};

export default MuiVideos;
